import type {
  CreateJobRequest,
  Job,
  JobDownload,
  JobsResponse,
} from "@facade/contracts";

import { api } from "@facade/api";

export const jobsApi = {
  async getAll(limit = 100) {
    const { data } = await api.get<JobsResponse>("/jobs", {
      params: { limit },
    });
    return data.jobs;
  },

  async getById(jobId: string) {
    const { data } = await api.get<Job>(`/jobs/${jobId}`);
    return data;
  },

  async create(request: CreateJobRequest, idempotencyKey: string) {
    const { data } = await api.post<Job>("/jobs", request, {
      headers: { "Idempotency-Key": idempotencyKey },
    });
    return data;
  },

  async getDownload(jobId: string) {
    const { data } = await api.get<JobDownload>(`/jobs/${jobId}/download-url`);
    return data;
  },
};
